export const SPEC_STORAGE_KEY = "surveySpecifications";


export function readSurveySpecs() {
  try {
    return JSON.parse(localStorage.getItem(SPEC_STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function patchSurveySpecs(patch) {
  const current = readSurveySpecs();
  const next = { ...current, ...patch };
  localStorage.setItem(SPEC_STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function clearSurveySpecs() {
  localStorage.removeItem(SPEC_STORAGE_KEY);
}


function draftKey(userId) {
  return `pendingGenerateDraft:${userId || "anon"}`;
}

export function savePendingGenerateDraft(userId, step, data = {}) {
  if (!userId) return;
  const existing = readPendingGenerateDraft(userId) || {};
  const next = {
    ...existing,
    ...data,
    step,
    updatedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(draftKey(userId), JSON.stringify(next));
  } catch {
  }
  return next;
}

export function readPendingGenerateDraft(userId) {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(draftKey(userId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingGenerateDraft(userId) {
  if (!userId) return;
  localStorage.removeItem(draftKey(userId));
}


export function resumeRouteForDraft(draft) {
  if (!draft) return null;

  switch (draft.step) {
    case "specs":
      return { path: "/add-survey", state: {} };
    case "robustness":
      return { path: "/survey-robustness", state: {} };
    case "generated":
      return {
        path: "/generated-survey",
        state: { resumeRequestId: draft.requestId },
      };
    case "audience":
      return {
        path: "/define-audience",
        state: {
          flow: "generated",
          surveyId: draft.surveyId,
          projectId: draft.projectId,
          audienceGroupId: draft.audienceGroupId,
          surveyName: draft.surveyName,
        },
      };
    default:
      return { path: "/add-survey", state: {} };
  }
}

const MAX_STEP_STORAGE_KEY = "surveyGenerateMaxStep";
const GENERATE_STEP_ORDER = ["specs", "robustness", "generated", "audience"];

export function getMaxStepReached() {
  try {
    const stored = localStorage.getItem(MAX_STEP_STORAGE_KEY);
    return GENERATE_STEP_ORDER.includes(stored) ? stored : null;
  } catch {
    return null;
  }
}
export function markStepReached(step) {
  if (!GENERATE_STEP_ORDER.includes(step)) return null;
  try {
    const current = getMaxStepReached();
    const currentIndex = GENERATE_STEP_ORDER.indexOf(current);
    const nextIndex = GENERATE_STEP_ORDER.indexOf(step);
    if (nextIndex > currentIndex) {
      localStorage.setItem(MAX_STEP_STORAGE_KEY, step);
      return step;
    }
    return current;
  } catch {
    return null;
  }
}

export function clearMaxStepReached() {
  try {
    localStorage.removeItem(MAX_STEP_STORAGE_KEY);
  } catch {
  }
}